import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../components/error-dialog/error-dialog.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    public dialog: MatDialog,
    private router: Router,
  ) {}
  errorDialog(message: string, statusText: string): void {
    console.error(statusText);
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '400px',
      data: {
        message,
      },
    });
    dialogRef.afterClosed();
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((e: HttpErrorResponse) => {
        let message: string;
        //let statusText: string = e.statusText?.replace(/ /g, '_').toUpperCase() || 'UNKNOWN_ERROR';

        if (e.status === 0) {
          this.router.navigateByUrl('/server-error');
          return throwError(() => '');
        }

        if (e.status >= 500) {
          this.router.navigateByUrl('/server-error');
          return throwError(() => '');
        }

        // Handle client-side errors
        switch (e.status) {
          case 400:
            message = e.error.message || 'You have sent a bad payload';
            break;
          case 401:
            message = e.error.message || 'Login first to access resources';
            break;
          case 403:
            message = e.error.message || 'Forbidden access to resources';
            break;
          case 404:
            message = e.error.message || 'Page not found';
            break;
          case 422:
            message = e.error.message || 'Invalid body sent';
            break;
          default:
            message = 'Unhandled error occurred';
            break;
        }
        console.error(message, e.statusText);
        return throwError(() => e);
      }),
    );
  }
}
